import { STORE_KEY_ID_LIST } from 'Constants'
import { storeGet } from 'mailup-react-helpers'
import {
  BADGE_TYPE_DEFAULT,
  BADGE_TYPE_ERROR,
  BADGE_TYPE_GREEN,
  BADGE_TYPE_ORANGE,
  BADGE_TYPE_SUCCESS,
  BADGE_TYPE_WARNING,
} from 'mailup-web-components'
import { pendoTrack } from './pendoTracking'

export const deliverabilityPendoTrack = (
  title: string,
  TipType: string,
  TipSubType: string,
  Score: number,
): void => {
  if (TipSubType && TipSubType !== 'TipsNotFound') {
    pendoTrack(title, {
      DateTime: new Date().toISOString(),
      TipType,
      TipSubType,
      List: storeGet(STORE_KEY_ID_LIST),
      Score: Math.round(Score),
    })
  }
}

export const getDeliverabilityScoreColor = (Score: number): string => {
  switch (true) {
    case Score < 30:
      return BADGE_TYPE_ERROR
    case Score < 50:
      return BADGE_TYPE_ORANGE
    case Score < 70:
      return BADGE_TYPE_WARNING
    case Score < 90:
      return BADGE_TYPE_GREEN
    case Score >= 90:
      return BADGE_TYPE_SUCCESS
    default:
      return BADGE_TYPE_DEFAULT
  }
}
